export function parseCurveValues(text = '') {
  let lines = text.split('\n').filter((line) => line.replace(/ /g, '') !== '');
  let result = { columnIndex: [] };
  // the 2 first lines are information about the data
  // the first line is the label
  // the second line is the unit
  for (let i = 0; i < lines.length; i++) {
    let fields = lines[i].trim().split(/ {2,}/);
    if (i === 0) {
      result.labels = fields;
      result.data = new Array(fields.length);
      for (let j = 0; j < fields.length; j++) {
        result.columnIndex[fields[j]] = j;
        result.data[j] = [];
      }
    } else if (i === 1) {
      result.units = new Array(result.labels.length - fields.length);
      result.units = result.units.concat(
        fields.map((field) => field.replace(/[[\]]/g, '')),
      );
    } else {
      if (fields.length !== result.labels.length) {
        throw new Error('Can not parse data for line: ', fields);
      }
      for (let j = 0; j < fields.length; j++) {
        let value = Number(fields[j]);
        if (isNaN(value)) {
          throw new Error('Problem parsing number: ', fields[j]);
        }
        result.data[j].push(value);
      }
    }
  }
  return result;
}
